module.exports = __webpack_public_path__ + "static/image/history/pc/202311.ver2_0_2.jpg?63a02159";